import { Injectable } from '@angular/core';
import { environment } from '../../enviroment/enviroment';

declare global {
  interface Window { AWS: any; }
}

@Injectable({
  providedIn: 'root'
})
export class AwsConfigService {
  constructor() {
    if (typeof window !== 'undefined') {
      window.AWS.config.update({
        region: environment.region, 
        credentials: new window.AWS.CognitoIdentityCredentials({
          IdentityPoolId: environment.identityPoolId
        })
      });
    }
  }
}